import { QN_VIDEO_COUNT_PER_PAGE } from "@config/quickNews";
import fetchBHApi from "@helper/fetchBHApi";
import { LatestVideoResponse } from "@transformer/useBrightcoveResponse";
import { ProcessedArticleData } from "@transformer/useOSResponse";
import { MoreArticlesRequestData } from "@typings/MoreArticlesApi";
import { PlaylistType } from "@typings/Playlist.d";

// ---------------------------- API Calls ------------------------------
export async function getMoreVideos(
  offset: number,
): Promise<LatestVideoResponse[]> {
  return await fetchBHApi<LatestVideoResponse[]>(
    `latest-videos-playlist?playlistId=${PlaylistType.SHORT_FORM}&offset=${offset}&size=${QN_VIDEO_COUNT_PER_PAGE}`,
    "GET",
  );
}

export async function getMoreFeeds(
  requestData: MoreArticlesRequestData,
  loadOlderArticles?: boolean,
): Promise<ProcessedArticleData[]> {
  const queryParams = new URLSearchParams({
    sort: Array.isArray(requestData.sort) ? requestData.sort.join(",") : "",
    more: loadOlderArticles ? "older" : "today",
  }).toString();
  return await fetchBHApi<ProcessedArticleData[]>(
    `get-quicknews-articles?${queryParams}`,
    "GET",
  );
}
